module.exports = __webpack_public_path__ + "img/Eduardo-Palacio.06efeb6b.png";